import styled from '@emotion/styled';
import { Icon } from '@mdi/react';
import { BaseButton, Variables } from '../../base';

export const Header = styled.div`
    display: flex;
    align-items: center;
    background-color: ${Variables.ThemeLight.Background2};
    border-bottom: 1px solid ${Variables.Colors.n15};
    padding: 16px 24px;
`;

export const HeaderLabels = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-grow: 1;
    gap: 8px;
`;

export const HeaderTextBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
`;

export const NameRow = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
`;

export const CreatedBy = styled.span`
    font-size: 14px;
    font-weight: ${Variables.FontWeight.semibold};
    line-height: 1.2;
    color: ${Variables.Colors.n100};
`;

export const AiBadge = styled.span`
    display: inline-flex;
    align-items: center;
    font-size: 10px;
    font-weight: ${Variables.FontWeight.semibold};
    letter-spacing: 0.05em;
    text-transform: uppercase;
    padding: 3px 6px 2px;
    border-radius: 4px;
    background: ${Variables.ThemeLight.PrimaryMild1};
    color: ${Variables.ThemeLight.PrimaryConstant6};
    border: 1px solid ${Variables.ThemeLight.PrimaryMild2};
`;

export const CreatedDate = styled.span`
    font-size: 12px;
    font-weight: ${Variables.FontWeight.regular};
    line-height: 1.35;
    color: ${Variables.Colors.n70};
`;

export const CreatedMeta = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
`;

export const MetaIcon = styled(Icon)`
    color: ${Variables.Colors.n50};
`;

export const BackButton = styled(BaseButton)`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: unset;
    height: auto;
    background: transparent;
    background-color: transparent;
    border: none;
    border-radius: 0;
    padding: 0;
    margin-right: 12px;
    cursor: pointer;
    color: ${Variables.Colors.n50};
    transition: color 0.2s ease;

    &:hover {
        color: ${Variables.Colors.n70};
        background: transparent;
        background-color: transparent;
    }
`;

export const CloseButton = styled(BaseButton)`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: unset;
    height: auto;
    background: transparent;
    background-color: transparent;
    border: none;
    border-radius: 0;
    padding: 0;
    cursor: pointer;
    color: ${Variables.Colors.n50};
    transition: color 0.2s ease;

    &:hover {
        color: ${Variables.Colors.n70};
        background: transparent;
        background-color: transparent;
    }
`;

export const CloseIcon = styled(Icon)``;

export const BackIcon = styled(Icon)``;

export const HeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    flex: none;
    margin-left: 8px;
`;

interface IStatusChip {
    status: 'needs_you' | 'done';
}

const statusChipThemes = {
    needs_you: {
        bg: Variables.ThemeLight.AttentionOpacity3,
        fg: Variables.ThemeLight.AttentionInverted4,
        bd: Variables.ThemeLight.AttentionInverted8,
        dot: Variables.ThemeLight.AttentionConstant6,
    },
    done: {
        bg: Variables.ThemeLight.SuccessOpacity3,
        fg: Variables.ThemeLight.SuccessInverted2,
        bd: Variables.ThemeLight.SuccessInverted8,
        dot: Variables.ThemeLight.SuccessConstant6,
    },
};

export const StatusChip = styled.span<IStatusChip>`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    flex: none;
    font-size: 11px;
    font-weight: ${Variables.FontWeight.semibold};
    letter-spacing: 0.04em;
    text-transform: uppercase;
    line-height: 1;
    padding: 4px 8px 3px;
    border-radius: 4px;
    white-space: nowrap;
    border: 1px solid ${(props: IStatusChip) => statusChipThemes[props.status].bd};
    background: ${(props: IStatusChip) => statusChipThemes[props.status].bg};
    color: ${(props: IStatusChip) => statusChipThemes[props.status].fg};
`;

export const StatusDot = styled.span<IStatusChip>`
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${(props: IStatusChip) => statusChipThemes[props.status].dot};
`;
